/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Project_Saved_Success_ToastInputs */



/**
* | output |
* | --- |
* | "Project saved successfully" |
*
* @param {Shortcut_Keys_Project_Saved_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_project_saved_success_toast = /** @type {((inputs?: Shortcut_Keys_Project_Saved_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Project_Saved_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Projet enregistre avec succes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projekt erfolgreich gespeichert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Progetto salvato con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проект успешно спасен")
	if (locale === "es") return /** @type {LocalizedString} */ ("Proyecto guardado exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("项目已成功保存")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトが正常に保存されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट सफलतापूर्वक सहेज लिया गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Projeto salvo com sucesso")
	return /** @type {LocalizedString} */ ("Project saved successfully")
});